import Papa from 'papaparse'
import PropTypes from 'prop-types'
import * as XLSX from 'xlsx/xlsx.mjs'

const convertCSVToExcelAndDownload = async (csvFile, fileName = null) => {
  const csvData = await parseCSV(csvFile)

  if (csvData) {
    const excelBlob = convertToExcelBlob(csvData)
    downloadExcelBlob(excelBlob, fileName)
  }
}

const parseCSV = (file) => {
  return new Promise((resolve) => {
    Papa.parse(file, {
      complete: (result) => {
        resolve(result.data)
      },
    })
  })
}

const convertToExcelBlob = (csvData) => {
  const ws = XLSX.utils.json_to_sheet(csvData, { skipHeader: true })
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

  const excelBlob = new Blob([s2ab(XLSX.write(wb, { bookType: 'xlsx', type: 'binary' }))], {
    type: 'application/octet-stream',
  })

  return excelBlob
}

const downloadExcelBlob = (blob, fileName) => {
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = fileName ? `${fileName}.xlsx` : 'data.xlsx'
  link.click()
}

const s2ab = (s) => {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xff
  }
  return buf
}

export default convertCSVToExcelAndDownload

convertCSVToExcelAndDownload.propTypes = {
  csvFile: PropTypes.instanceOf(File).isRequired,
  fileName: PropTypes.string,
}
